import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles,
  Theme,
  createStyles,
} from "@material-ui/core";

/** スタイル定義 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const useStyles = makeStyles((_theme: Theme) =>
  createStyles({
    title: {
      "& h2": {
        fontSize: "1rem",
      },
    },
  })
);

interface Props {
  open: boolean;
  title?: string;
  okLabel?: string;
  handleClose: () => void;
  children?: React.ReactNode;
}

/** 設定画面ダイアログ */
export function ConfigDialog(props: Props) {
  const classes = useStyles();

  const { open, title, okLabel, handleClose, children } = props;

  //--------------------
  // コンポーネント
  return (
    <div>
      <Dialog
        maxWidth="lg"
        open={open}
        onClose={handleClose}
        disableBackdropClick
        disableEscapeKeyDown
      >
        <DialogTitle className={classes.title}>{title}</DialogTitle>
        <DialogContent>
          {children}
          {/* <DialogContentText></DialogContentText> */}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {okLabel || "OK"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
